import { AlarmLevel } from '../enums/alarm-level.enum';
import { UpdateAlarmRuleCommand } from './update-alarm-rule-command.contract';

export interface UpdateTransportAlarmRuleCommand {
  alarmRuleId: string;
  alarmLevel: AlarmLevel;
  alarmMessage: string;
  userRolesEmailRecipients?: string[];
  emailRecipients: string[];
}

export function toUpdateTransportAlarmRuleCommand(command: UpdateAlarmRuleCommand): UpdateTransportAlarmRuleCommand {
  const { alarmRuleId, alarmLevel, alarmMessage, userRolesEmailRecipients, emailRecipients } = command;
  return {
    alarmRuleId,
    alarmLevel,
    alarmMessage,
    userRolesEmailRecipients,
    emailRecipients,
  };
}
